import {
  CircularProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import Dialog from "../Dialog";
import { useAtom } from "jotai";
import { format } from "../../../utils/fn-utils";
import { useTranslation } from "react-i18next";
import { getAllPublishers } from "../../../services/publisherService";
import { useQuery } from "react-query";
import { styled } from "@mui/system";
import Checkbox from "../Checkbox";
import { useState } from "react";
import {
  publisherNameAtom,
  selectedPublisherIdAtom,
} from "../../../atom/atoms";
const StyledList = styled(List)`
  padding-top: 0;
  padding-bottom: 0;
  border-left: 1px solid #a8a8a8;
  max-height: 15rem;
  & .li:hover {
    height: 26;
  }
  & li:nth-child(even) {
    background-color: ${(props) => props.theme.palette.background.default};
  }
`;
const StyledDialog = styled(Dialog)`
  & .MuiPaper-root {
    border: 12px solid ${(props) => props.theme.palette.background.paper};
    border-radius: ${(props) => props.theme.shape.borderRadius}px;
    background-color: ${(props) => props.theme.palette.background.default};
    background-image: none;
    height: 30rem;
    width: 30rem;
    justify-content: center;
    justify-items: center;
    align-content: center;
    align-items: center;
  }
`;

const PUBLISHER_LENGTH = 21;

const PublisherSelectionDialog = ({ isDialogOpen, setIsDialogOpen }) => {
  const { data, error, isLoading } = useQuery(
    "getAllPublishers",
    getAllPublishers
  );
  const [, setSelectedPublisherId] = useAtom(selectedPublisherIdAtom);
  const [selectedItem, setSelectedItem] = useState();
  const [, setPublisherName] = useAtom(publisherNameAtom);
  const [selectedId, setSelectedId] = useState(null);
  // checks if publisher name is more than 15 chars
  // and if it is returns a sliced string with ... in the end
  const { locale } = useTranslation();

  const formatDate = (created) => {
    return format(new Date(created), "dd/MM/yyyy", locale);
  };
  const modifiedPubliserName = (publisherName) => {
    if (publisherName.length > PUBLISHER_LENGTH) {
      return publisherName.slice(0, PUBLISHER_LENGTH) + "...";
    } else {
      return publisherName;
    }
  };
  const setPublisherIdAndNameInSessionStorage = (item) => {
    setSelectedPublisherId(item?.id);
    setPublisherName(item?.publisherName);
    setSelectedId(item?.id);
  };

  return (
    <>
      <StyledDialog
        primaryButtomText="Select"
        title={"Select a publisher"}
        maxWidth="xl"
        fullWidth="xl"
        open={isDialogOpen}
        action={() => {
          if (selectedId) {
            setPublisherIdAndNameInSessionStorage(selectedItem);
            setIsDialogOpen(false);
          }
        }}
      >
        {!isLoading && !error && (
          <StyledList
            sx={{
              width: "100%",
              minWidth: 326,
              maxWidth: 326,
              bgcolor: "background.paper",
              borderLeft: "0",
            }}
          >
            {data?.map((item) => {
              const labelId = `checkbox-list-secondary-label-${item?.id}`;
              return (
                <ListItem
                  key={item.id}
                  secondaryAction={
                    <Checkbox
                      onChange={() => {
                        setSelectedItem(item);
                        setSelectedId(item?.id);
                      }}
                      checked={selectedId === item?.id}
                      edge="end"
                      inputProps={{ "aria-labelledby": labelId }}
                    />
                  }
                  disablePadding
                >
                  <Tooltip
                    title={item?.publisherName ? item?.publisherName : ""}
                    placement="right"
                  >
                    <ListItemButton
                      style={{
                        background: "#fefefe",
                        borderBottom: "1px solid #e4e9f3",
                      }}
                      onClick={() => {
                        setSelectedItem(item);
                        setSelectedId(item?.id);
                      }}
                    >
                      <ListItemText
                        id={labelId}
                        primary={modifiedPubliserName(`${item?.publisherName}`)}
                      />
                      <span style={{ marginRight: "14px" }}>
                        {formatDate(item?.created)}
                      </span>
                    </ListItemButton>
                  </Tooltip>
                </ListItem>
              );
            })}
          </StyledList>
        )}
        {isLoading && <CircularProgress />}
        {error && <Typography textAlign={"center"}>{error.message}</Typography>}
      </StyledDialog>
    </>
  );
};

export default PublisherSelectionDialog;
